const en = {
  common: {
    username: 'Username',
    password: 'Password',
    search: 'Search',
    continue: 'Continue',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    move: 'Move',
    restore: 'Restore',
    edit: 'Edit',
    addMenu: 'Create new menu',
    addContent: 'Add to menu',
    addToSubmenu: 'Add to submenu',
    addSubmenu: 'Create submenu',
    delete: 'Delete',
    language: 'Language',
    struct: 'Struct',
    selectImage: 'Select image',
    height: 'Height',
    url: 'URL',
    text: 'Text',
    comment: 'Comment',

    collapse: 'Collapse',
    expand: 'Expand',

    today: 'Today',
    tomorrow: 'Tomorrow',
    m0: 'January',
    m1: 'February',
    m2: 'March',
    m3: 'April',
    m4: 'May',
    m5: 'June',
    m6: 'July',
    m7: 'August',
    m8: 'September',
    m9: 'October',
    m10: 'November',
    m11: 'December',
    dayOfWeek: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    },

    addToCalendar: 'Add to calendar',
    error2mb: 'The image cannot exceed 2MB',
    selectMenu: 'Select the menu to move the content',
    addressToSearch: 'Address',
    history: 'History'
  },
  login: {
    title: 'Login form',
    login: 'login',
    messages: {
      required: 'Username and password are required',
      userNotFound: 'The username or password is incorrect',
      moveContent: 'Move content',
      cloneMenu: 'Clone menu'
    }
  },
  dashboard: {
    title: 'Dashboard',
    changePassword: 'Change password',
    logout: 'Logout',
    changeEnterprise: 'Change enterprise',
    addReservation: 'Add reservation'
  },
  changePassword: {
    oldPassword: 'Old password',
    password: 'New password',
    repeatPassword: 'Repeat password',
    messages: {
      oldPasswordRequired: 'The previous password is required',
      passwordRequired: 'Password is required',
      sameAsPassword: 'Passwords must match',
      UserNotFound: 'Username or password does not match',
      success: 'Password updated successfully'
    },
  },
  users: {
    title: 'Users',
    userTitle: 'User',
    name: 'Name',
    email: 'Email',
    client: 'Client',
    password: 'Password',
    repeatPassword: 'Repeat password',
    isSuperUser: 'Is superuser',
    enterprises: 'Groups',
    defaultEnterprise: 'Client by default',
    permissions: {
      title: 'Permissions',
    },
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      emailValid: 'Must be valid e-mail',
      emailRequired: 'E-mail is required'
    },
    notification: 'Nortification'
  },
  enterprises: {
    title: 'Groups',
    enterpriseTitle: 'Group',
    name: 'Group',
    domain: 'Domain',
    privateBGColor: 'Admin private color',
    permissions: 'Permissions',
    dviewLink: 'Activities (Dview link)',
    dviewLinkShows: 'Shows (Dview link)',
    dviewLinkAgenda: 'Agenda (Dview link)',
    dviewLinkParrilla: 'Parrilla (Dview link)',
    dviewLinkCommercial: 'Commercial (Dview link)',
    dviewLinkProperty: 'Property (Dview link)',
    showMoscaDFeel: 'Show mosca DFeel',
    meteo: 'Meteo (zone)',
    linkCommon: 'Enlazar menús compartidos',
    clearStats: 'Reset stats',
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      domainMostCharacters: 'Domain must be at most 50 characters long',
      domainRequired: 'Domain is required'
    }
  },
  playerSettings: {
    title: 'Players',
    playerSettingTitle: 'Player',
    name: 'Name',
    token: 'Token',
    delay: 'Delay'
  },
  status: {
    title: 'Status'
  },
  confirmDelete: {
    title: 'Do you want to remove this content?',
    message: 'This action cannot be reversed.'
  },
  confirmUndo: {
    title: 'Do you want cotinue?',
    message: 'Unsaved modifications will be deleted'
  },
  statusRoom: {
    scheduleMeeting: 'Schedule meeting'
  }
}
  
export default en
  